import React from "react";
import Link from "helpers/link";
import Image from "components/image";
import { Swiper, SwiperSlide } from "components/swiper";
import {
	Navigation, A11y, Mousewheel, Autoplay
} from "swiper";
import { getRgba } from "helpers/get-rgba";


const AnnouncementBarSlider = ({ data, bgColor, txtColor }) => {

	const settings = {
		modules: [Navigation, A11y, Mousewheel, Autoplay],
		slidesPerView: 1,
		preventClicks: true,
		preventClicksPropagation: false,
		noSwiping: true,
		freeMode: true,
		autoplay: {
			delay: 5000,
			pauseOnMouseEnter: true,
			disableOnInteraction: false
		},
		spaceBetween: 10,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		slidesPerGroup: 1,
		a11y: true,
	};

	return (
		<div className="announcement-bar-slider min-h-14 md:pt-2.5" style={{
			backgroundColor: getRgba(bgColor),
			color: getRgba(txtColor),
		}}>
			<Swiper {...settings}>
				{data?.map((item, i) => {
					return (
						<SwiperSlide key={i}>
							<Link to={item?.link ?? ""}>
								<div className="flex flex-row justify-center align-center">
									{item?.icon &&
										<Image
											image={item?.icon}
											alt={item?.icon?.alt}
											style={{ width: "40px", height: "40px" }}
											className="focus-outline-ay11"
										/>}
									<div
										dangerouslySetInnerHTML={{ __html: item?.text }}
										className="w-full text-center p-2 tracking-widest md:text-base text-sm"
									></div>
								</div>
							</Link>
						</SwiperSlide>
					);
				})}
			</Swiper>
		</div >
	);
};

export default AnnouncementBarSlider;